module.exports = __webpack_public_path__ + "static/fee06-3535f96cfd0e284f6d2ca376a6b9700c.png";